module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("\n    Manual Credit\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "bg-blue-grey-100 p-30"
  }, [_c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    attrs: {
      "alertClass": "m-b-25 alert-dismissible",
      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
    }
  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitManualCredit($event)
      }
    }
  }, [_c('form-group', [_c('label', {
    staticClass: "form-control-label form-radio"
  }, [_vm._v("Choose Type")]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transactionType),
      expression: "transactionType"
    }],
    attrs: {
      "type": "radio",
      "id": "deposit",
      "value": "deposit"
    },
    domProps: {
      "checked": _vm._q(_vm.transactionType, "deposit")
    },
    on: {
      "click": function($event) {
        _vm.transactionType = "deposit"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payplan"
    }
  }, [_vm._v("Add")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transactionType),
      expression: "transactionType"
    }],
    attrs: {
      "type": "radio",
      "id": "deduct",
      "value": "deduct"
    },
    domProps: {
      "checked": _vm._q(_vm.transactionType, "deduct")
    },
    on: {
      "click": function($event) {
        _vm.transactionType = "deduct"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payplan"
    }
  }, [_vm._v("Deduct")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('amount')
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Amount (THB)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('description')
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Note for admin (Not show to user)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    class: {
      'btn-default': _vm.isSubmiting
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmiting
    }
  }, [(_vm.isSubmiting) ? _c('div', {
    staticClass: "loader vertical-align-middle loader-circle loader-form"
  }) : _vm._e(), _vm._v(" Submit\n            ")])], 1)], 1)])]), _vm._v(" "), _c('p')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70c55eeb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/teams/ManualCredit.vue
// module id = 544
// module chunks = 1